class BaseError extends Error {}

export class NotReceiveFileList extends BaseError {}

export class UnknownError extends BaseError {}
